import React from 'react';
import Navbar from '../components/Navbar';
import Projects from '../components/Projects';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import SEOHelmet from '../components/SEOHelmet';
import { pagesSEO } from '../utils/seoConfig';

const ProjectsPage = () => {
  return (
    <div className="projects-page">
      <SEOHelmet 
        title={pagesSEO.projects.title}
        description={pagesSEO.projects.description}
        keywords={pagesSEO.projects.keywords}
        canonical={pagesSEO.projects.canonical}
      />
      <Navbar />
      <Breadcrumb />
      <main>
        <h1 className="page-title sr-only">設計作品 - 聯漢室內設計工作室</h1>
        <Projects />
      </main>
      <Footer />
    </div>
  );
};

export default ProjectsPage; 